import { render, staticRenderFns } from "./ForeignWorkSearch.vue?vue&type=template&id=47da6fe7&scoped=true"
import script from "./ForeignWorkSearch.vue?vue&type=script&lang=js"
export * from "./ForeignWorkSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47da6fe7",
  null
  
)

export default component.exports